import { useState } from 'react';
import { CancellationPolicyOverviewEntry } from '@mews-commander/data-access';
import { Table, TableHeader, TableProvider, useTableState } from '@optimus-web/core';
import { LocalizedText, lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { useCancellationPoliciesGetOverviewEntriesQuery } from '../queries';
import { getCancellationPoliciesColumns } from './columns';
import { CancellationPolicySidePanel } from './CancellationPolicySidePanel';
import { CreateCancellationPolicyDialog } from './CreateCancellationPolicyDialog';

export const CancellationPolicies = () => {
    const [tableState, setTableState] = useTableState<CancellationPolicyOverviewEntry>();

    const { isFetching, data } = useCancellationPoliciesGetOverviewEntriesQuery(tableState);

    const [selectedCancellationPolicyId, setCancellationPolicyId] = useState<string>();

    return (
        <>
            <TableProvider
                state={tableState}
                columns={getCancellationPoliciesColumns({
                    onNameClick: setCancellationPolicyId,
                })}
                onStateChange={setTableState}
                as="div"
            >
                <TableHeader
                    title={<LocalizedText textKey={TextKey.CancellationPolicyPlural} />}
                    rightSide={<CreateCancellationPolicyDialog />}
                    subTitle={data?.totalRowCount || '0'}
                />
                <Table
                    loading={isFetching}
                    uniqueRowId="id"
                    data={data?.data ?? []}
                    amountOfRows={data?.totalRowCount ?? 0}
                    emptyState={{
                        primaryText: lt('CancellationPolicyTableEmptyStatePrimaryText'),
                        secondaryText: lt('CancellationPolicyTableEmptyStateSecondaryText'),
                        action: <CreateCancellationPolicyDialog />,
                    }}
                />
            </TableProvider>
            <CancellationPolicySidePanel
                cancellationPolicyId={selectedCancellationPolicyId}
                handleCloseSidePanel={() => setCancellationPolicyId(undefined)}
            />
        </>
    );
};
